// extracted by mini-css-extract-plugin
module.exports = {"centered":"PageHeader_centered__NuTaf","spaceBetween":"PageHeader_spaceBetween__nQDeB","title":"PageHeader_title__SWNyD"};